import { useMemo } from 'react';
import { useEmployeeStore } from '../store/employeeStore';
import { useAccountBookStore } from '../store/accountBookStore';

export const useEmployeeActions = () => {
  // 필요한 값만 구독
  const createEmployee = useEmployeeStore((state) => state.createEmployee);
  const updateEmployee = useEmployeeStore((state) => state.updateEmployee);
  const deleteEmployee = useEmployeeStore((state) => state.deleteEmployee);
  const deleteRetiredEmployee = useEmployeeStore((state) => state.deleteRetiredEmployee);
  const createSchedule = useEmployeeStore((state) => state.createSchedule);
  const updateSchedule = useEmployeeStore((state) => state.updateSchedule);
  const deleteSchedule = useEmployeeStore((state) => state.deleteSchedule);
  const copyDaySchedules = useEmployeeStore((state) => state.copyDaySchedules);
  const loading = useEmployeeStore((state) => state.loading);
  const error = useEmployeeStore((state) => state.error);
  
  const userId = useAccountBookStore((state) => state.userId);
  const currentAccountBook = useAccountBookStore((state) => state.currentAccountBook);

  // userId와 accountNumber를 자동으로 포함하는 래퍼 함수들 (useMemo로 메모이제이션)
  const actions = useMemo(() => ({
    createEmployee: (employee: any) => {
      if (!userId) throw new Error('사용자가 로그인되지 않았습니다.');
      if (!currentAccountBook) throw new Error('가계부가 선택되지 않았습니다.');
      return createEmployee(userId, { ...employee, accountNumber: currentAccountBook.accountNumber });
    },
    updateEmployee: (employeeId: string, updates: any, options?: { updateType?: 'fullUpdate' | 'newOnly'; reason?: string }) => {
      if (!userId) throw new Error('사용자가 로그인되지 않았습니다.');
      return updateEmployee(userId, employeeId, updates, options);
    },
    deleteEmployee: (employeeId: string) => {
      if (!userId) throw new Error('사용자가 로그인되지 않았습니다.');
      return deleteEmployee(userId, employeeId);
    },
    deleteRetiredEmployee: (
      employeeId: string,
      deleteWorkRecords: boolean,
    ) => {
      if (!userId) throw new Error('사용자가 로그인되지 않았습니다.');
      if (!currentAccountBook) throw new Error('가계부가 선택되지 않았습니다.');
      return deleteRetiredEmployee(userId, employeeId, {
        deleteWorkRecords,
        accountNumber: currentAccountBook.accountNumber,
      });
    },
    createSchedule: (schedule: any) => {
      if (!userId) throw new Error('사용자가 로그인되지 않았습니다.');
      if (!currentAccountBook) throw new Error('가계부가 선택되지 않았습니다.');
      return createSchedule(userId, { ...schedule, accountNumber: currentAccountBook.accountNumber });
    },
    updateSchedule: (scheduleId: string, updates: any) => {
      if (!userId) throw new Error('사용자가 로그인되지 않았습니다.');
      return updateSchedule(userId, scheduleId, updates);
    },
    deleteSchedule: (scheduleId: string) => {
      if (!userId) throw new Error('사용자가 로그인되지 않았습니다.');
      return deleteSchedule(userId, scheduleId);
    },
    copyDaySchedules: (sourceDateStr: string, targetDateStrs: string[]) => {
      if (!userId) throw new Error('사용자가 로그인되지 않았습니다.');
      if (!currentAccountBook) throw new Error('가계부가 선택되지 않았습니다.');
      return copyDaySchedules(userId, sourceDateStr, targetDateStrs);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [userId, currentAccountBook?.accountNumber]);

  return {
    ...actions,
    loading,
    error
  };
};
